import { Box, Chip, Paper, Tooltip, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone/.';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

export const DropzoneUpload = ({ label, onFileSelect, multiple = false, required = false }) => {
  const [selectedFiles, setSelectedFiles] = useState([]);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    multiple,
    onDrop: acceptedFiles => {
      const files = multiple ? acceptedFiles : [acceptedFiles[0]];
      setSelectedFiles(files);
      if (onFileSelect) {
        onFileSelect(multiple ? files : files[0]);
      }
    },
  });

  return (
    <Box
      sx={{
        '& .MuiTableCell-root': {
          fontSize: '0.825rem',
        },
        '& .MuiInputBase-root': {
          fontSize: '0.825rem !important',
        },
        '& .MuiTypography-root': {
          fontSize: '0.825rem !important',
        },
      }}>
      <Typography variant="subtitle1" gutterBottom>
        {label}{' '}
        {required && (
          <Typography component="span" color="error">
            *
          </Typography>
        )}
      </Typography>

      <div
        {...getRootProps()}
        style={{
          position: 'relative',
          overflow: 'visible',
          height: 'auto',
        }}>
        <Paper
          elevation={0}
          sx={{
            border: '2px dashed #ccc',
            backgroundColor: isDragActive ? '#f0faff' : 'transparent',
            p: 3,
            textAlign: 'center',
            cursor: 'pointer',
            height: 120,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
          <input required={required} {...getInputProps()} />
          <CloudUploadIcon sx={{ fontSize: 40, mb: 1, color: 'gray' }} />
          <Typography variant="body1" fontWeight="bold">
            Browse Files
          </Typography>
          <Typography variant="body2" color="text.secondary">
            or drag and drop files here
          </Typography>
        </Paper>
      </div>
      <Box
        mt={1}
        sx={{
          display: 'flex',
          overflowX: 'auto',
          gap: 1,
          py: 1,
          px: 0.5,
        }}>
        {selectedFiles.length > 0 &&
          selectedFiles.map((file, index) => (
            <Tooltip title={file.name}>
              <Chip
                key={index}
                label={file.name.length > 20 ? file.name.slice(0, 18) + '…' : file.name}
                color="primary" // red primary color
                sx={{
                  fontSize: '0.7rem', // Slightly bigger text
                  height: '24px',
                  px: 1,
                }}
              />
            </Tooltip>
          ))}
      </Box>
    </Box>
  );
};
